import { SvgIcon } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';

const PaymentStatusWaiting = (props) => {
  const _themeColor = useSelector((state) => state?.header?.themeColor);
  return (
    <SvgIcon {...props}>
      <svg
        width="20"
        height="21"
        viewBox="0 0 20 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <title>En attente</title>
        <g clipPath="url(#clip0_740_23727)">
          <path
            d="M6.13574 5.27802C6.38122 6.79002 7.19683 8.22202 8.4242 9.11802C9.11312 9.61402 9.65158 9.83802 10 9.84602C10.3484 9.85402 10.8948 9.63002 11.5837 9.13402C12.819 8.24602 13.6425 6.82202 13.9038 5.31002C13.9197 5.20602 13.8959 5.09402 13.8247 5.00602C13.7534 4.92602 13.6504 4.87802 13.5475 4.87002L6.5 4.84602C6.38914 4.84602 6.28619 4.89402 6.22285 4.97402C6.15158 5.05402 6.11991 5.16602 6.14366 5.27802H6.13574Z"
            fill="#F7A614"
          />
          <path
            d="M3.7681 4.10201H4.21946V4.92601C4.21154 7.36601 5.37557 9.68601 7.33145 11.126L8.04412 11.654L7.32353 12.174C5.35973 13.598 4.17986 15.91 4.17195 18.35V19.174H3.72059C3.31674 19.182 3 19.502 3 19.902C3 20.302 3.31674 20.622 3.70475 20.622L16.224 20.67C16.6199 20.67 16.9367 20.35 16.9367 19.958C16.9367 19.566 16.6199 19.238 16.2319 19.238H15.7805V18.214C15.7805 16.062 14.6086 13.822 12.621 12.214L11.9559 11.678L12.621 11.15C14.6165 9.56601 15.8122 7.33401 15.8201 5.17401V4.15001H16.2715C16.6674 4.15001 16.9842 3.83001 16.9842 3.43801C16.9842 3.04601 16.6674 2.71801 16.2794 2.71801L3.77602 2.67001C3.38009 2.67001 3.06335 2.99001 3.06335 3.38201C3.06335 3.77401 3.38009 4.10201 3.7681 4.10201ZM14.767 5.16601C14.767 6.99001 13.7138 8.91001 11.9717 10.294L11.2749 10.846C11.0215 11.046 10.879 11.342 10.879 11.67C10.879 11.998 11.0215 12.294 11.267 12.494L11.9559 13.054C13.69 14.454 14.7195 16.374 14.7115 18.206V18.702C14.7115 18.99 14.474 19.23 14.1889 19.222L5.73982 19.19C5.45475 19.19 5.21719 18.95 5.22511 18.662V18.358C5.23303 16.262 6.24661 14.278 7.93326 13.054L8.68552 12.51C8.95475 12.318 9.12104 11.998 9.12104 11.662C9.12104 11.326 8.96267 11.006 8.69344 10.814L7.94909 10.262C6.27036 9.02201 5.27262 7.03801 5.28054 4.93401V4.63001C5.28054 4.34201 5.5181 4.10201 5.80317 4.11001L14.2523 4.14201C14.5373 4.14201 14.7749 4.38201 14.767 4.67001V5.16601Z"
            fill="#F7A614"
          />
        </g>
        <defs>
          <clipPath id="clip0_740_23727">
            <rect
              width="14"
              height="18"
              fill="white"
              transform="translate(3 2.67001)"
            />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
};

export default PaymentStatusWaiting;
